/** Metadata snapshots intentionally retain original asset references; no binary data or GC. */
export function makeHistory(limit = 100) {
    const past = [];
    const future = [];
    const view = () => ({ canUndo: past.length > 0, canRedo: future.length > 0, undoCount: past.length, redoCount: future.length });
    return {
        view,
        clear: () => { past.length = 0; future.length = 0; },
        record: (current) => { past.push(current); if (past.length > limit)
            past.shift(); future.length = 0; },
        peek: (direction) => (direction === "undo" ? past : future).at(-1),
        accept: (direction, current) => {
            const from = direction === "undo" ? past : future;
            const to = direction === "undo" ? future : past;
            from.pop();
            to.push(current);
        },
    };
}
